module.exports = __webpack_public_path__ + "img/online.f25a19af.jpg";